<template>
  <v-progress-circular v-on="$listeners" :rotate="rotation" :size="32" :width="4" :value="calculatedValue"
                       :indeterminate="!calculatedValue" :color="displayColor" class="profile-header-cursor">
    <div class="text-caption">{{ displayValue }}</div>
  </v-progress-circular>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { MapGetters } from '@core/helpers/decorators';

@Component
@MapGetters(['profilePercentage'])
export default class ProfileHeaderWidget extends Vue {
  get calculatedValue() {
    return this.profilePercentage || undefined;
  }

  get displayValue() {
    return this.calculatedValue || '';
  }

  get displayColor() {
    return this.$vuetify.breakpoint.smAndDown ? 'primary' : 'secondary';
  }

  get rotation() {
    return this.calculatedValue ? 270 : 0;
  }
}
</script>

<style scoped>
.profile-header-cursor{
  cursor: pointer;
}
</style>
